import React from "react";
import './widget.scss'
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import { green} from '@mui/material/colors';



export default function WidgetWalkon({Walkon,AllList}){

    const walkon = Walkon?.map( person => person.Value);
    const all = AllList?.map( person => person.Value);
    const percent = (walkon/all*100).toFixed(0);
   
  return (
    <div className='widget'>
        <div className='left'>
            <span className='title'>Walk-in Online</span>
            <span className='counter'>{walkon}</span>
        </div>
        <div className='right'>
            <div className="percentage positive">
                
                {percent}%
            </div>
                <AddToHomeScreenIcon sx={{ fontSize: 40 , color: green.A200}} />
        </div>
    </div>
  )
}